// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".full-size-dialog[data-v-ff8b7076] {\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  position: fixed;\n  z-index: 100;\n}\nhtml[data-v-ff8b7076] {\n  overflow: hidden !important;\n}", ""]);
// Exports
module.exports = exports;
